import { createAction, handleActions } from 'redux-actions';
import produce from 'immer';
import createRequestSaga, {
  createRequestActionTypes,
} from '../../lib/createRequestSaga';
import { takeLatest } from 'redux-saga/effects';
import * as authAPI from '../../lib/api/auth';

const [REGISTER, REGISTER_SUCCESS, REGISTER_FAILURE] = createRequestActionTypes(
  'auth/REGISTER',
);
const [LOGIN, LOGIN_SUCCESS, LOGIN_FAILURE] = createRequestActionTypes(
  'auth/LOGIN',
);

const INITILAIZER = 'auth/INITIALIZER';
const CHANGE_FIELD = 'auth/CHANGE_FIELD';
const INITIALIZE_FORM = 'auth/INITIALIZE_FORM';
const AUTO_LOGIN_TOGGLE = 'auth/AUTO_LOGIN_TOGGLE';
const LOAD_LOGIN_INFO = 'auth/LOAD_LOGIN_INFO';

export const changeField = createAction(
  CHANGE_FIELD,
  ({ form, key, value }) => ({
    form,
    key,
    value,
  }),
);
export const initializeForm = createAction(INITIALIZE_FORM, (form) => form);
export const initializer = createAction(INITILAIZER);
export const register = createAction(REGISTER, ({ account, password }) => ({
  account,
  password,
}));
export const autoLoginToggle = createAction(AUTO_LOGIN_TOGGLE);
export const loadLoginInfo = createAction(LOAD_LOGIN_INFO, (info) => info);
export const login = createAction(
  LOGIN,
  ({ account, password, socketKey }) => ({
    account,
    password,
    socketKey,
  }),
);

const registerSaga = createRequestSaga(REGISTER, authAPI.register);
const loginSaga = createRequestSaga(LOGIN, authAPI.login);
export function* authSaga() {
  yield takeLatest(REGISTER, registerSaga);
  yield takeLatest(LOGIN, loginSaga);
}

const initialState = {
  register: {
    account: '',
    password: '',
    passwordConfirm: '',
  },
  login: {
    account: '',
    password: '',
    autoLogin: false,
  },
  auth: null,
  authError: null,
};

const auth = handleActions(
  {
    [CHANGE_FIELD]: (state, { payload: { form, key, value } }) =>
      produce(state, (draft) => {
        draft[form][key] = value;
      }),
    [INITIALIZE_FORM]: (state, { payload: form }) => ({
      ...state,
      authError: null,
      [form]: initialState[form],
    }),
    [REGISTER_SUCCESS]: (state, { payload: auth }) => ({
      ...state,
      authError: null,
      auth,
    }),
    [REGISTER_FAILURE]: (state, { payload: error }) => ({
      ...state,
      authError: error,
    }),
    [LOGIN_SUCCESS]: (state, { payload: auth }) => ({
      ...state,
      authError: null,
      auth,
    }),
    [LOGIN_FAILURE]: (state, { payload: error }) => ({
      ...state,
      authError: error,
    }),
    [INITILAIZER]: (state) => ({ ...state, auth: null, authError: null }),
    [AUTO_LOGIN_TOGGLE]: (state) =>
      produce(state, (draft) => {
        draft['login']['autoLogin'] = !state.login.autoLogin;
      }),
    [LOAD_LOGIN_INFO]: (state, { payload: info }) => ({
      ...state,
      login: info,
    }),
  },
  initialState,
);

export default auth;
